<template>
  <section class="grid-container pb-16 tablet:pb-48">
    <div class="relative col-span-12 pt-24 pb-16 text-center tablet:col-start-3 tablet:col-end-11 laptop:pt-40">
      <img src="~/assets/images/cursor-army.png" class="absolute inset-x-0 -top-11" />

      <img src="~/assets/images/lightbulb.png" class="absolute top-0 left-1/2 w-8 -translate-x-1/2 laptop:w-auto" />

      <slot></slot>
    </div>
  </section>
</template>
